var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"liveplay h5container"},[_c('video',{staticClass:"h5video",attrs:{"id":_vm.videoid,"autoplay":"","webkit-playsinline":"","playsinline":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }